const appearance = {
  name: "appearance",
  path: "/appearance",
  title: "appearance",
  description: "Utilities for controlling the CSS appearance property.",
  value: {
    "appearance": {
      "appearance-none": "none",
      "appearance-auto": "auto"
    }
  },
  exampleData: [
    {
      example: {
        code: `<select>
  <option>Yes</option>
  <option>No</option>
  <option>Maybe</option>
</select>

<div class="grid">
  <select class="col-start-1 row-start-1 appearance-none bg-gray-50 dark:bg-gray-800 ...">
    <option>Yes</option>
    <option>No</option>
    <option>Maybe</option>
  </select>
  <svg class="pointer-events-none col-start-1 row-start-1 ...">
    <!-- ... -->
  </svg>
</div>`
      }
    }
  ],
  htmlData: [
    {
      title: "Appearance",
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-6">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">appearance-none</code> to remove browser default styling, or <code class="text-color-gray-800 dark:text-color-white font-semibold">appearance-auto</code> to restore it.
      </p>
<div class="mx-auto max-w-sm items-center">
   <div class="my-6 flex">
      <select class="w-20">
         <option>Yes</option>
         <option>No</option>
         <option>Maybe</option>
      </select>
      <div class="mx-6 text-sm font-semibold text-color-gray-900 dark:text-color-gray-200">Default browser styles applied</div>
   </div>
   <div class="my-6 flex items-center">
      <div class="grid">
         <svg class="pointer-events-none relative right-1 z-10 col-start-1 row-start-1 h-4 w-4 self-center justify-self-end forced-colors:hidden" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
            <path fill-rule="evenodd" d="M4.22 6.22a.75.75 0 0 1 1.06 0L8 8.94l2.72-2.72a.75.75 0 1 1 1.06 1.06l-3.25 3.25a.75.75 0 0 1-1.06 0L4.22 7.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd"></path>
         </svg>
         <select class="col-start-1 row-start-1 w-20 appearance-none rounded-lg border border-color-gray-300 bg-color-gray-50 px-2 text-color-gray-700 hover:border-color-cyan-500 hover:bg-white dark:border-color-gray-600 dark:bg-color-gray-800 dark:text-color-gray-200 dark:hover:border-color-cyan-700 dark:hover:bg-color-gray-700 forced-colors:appearance-auto">
            <option>Yes</option>
            <option>No</option>
            <option>Maybe</option>
         </select>
      </div>
      <div class="mx-6 text-sm font-semibold text-color-gray-900 dark:text-color-gray-200">Remove default browser styles</div>
   </div>
</div>
      `
    }
  ]
};

export default appearance;
<div class="mx-auto max-w-sm items-center sr-omly">
   <div class="my-6 flex">
      <select class="w-20">
         <option>Yes</option>
         <option>No</option>
         <option>Maybe</option>
      </select>
      <div class="mx-6 text-sm font-semibold text-gray-900 dark:text-gray-200">Default browser styles applied</div>
   </div>
   <div class="my-6 flex items-center">
      <div class="grid">
         <svg class="pointer-events-none relative right-1 z-10 col-start-1 row-start-1 h-4 w-4 self-center justify-self-end forced-colors:hidden" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
            <path fill-rule="evenodd" d="M4.22 6.22a.75.75 0 0 1 1.06 0L8 8.94l2.72-2.72a.75.75 0 1 1 1.06 1.06l-3.25 3.25a.75.75 0 0 1-1.06 0L4.22 7.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd"></path>
         </svg>
         <select class="col-start-1 row-start-1 w-20 appearance-none rounded-lg border border-color-gray-300 bg-gray-50 px-2 text-gray-700 hover:border-color-cyan-500 hover:bg-white dark:border-color-gray-600 dark:bg-gray-800 dark:text-gray-200 dark:hover:border-color-cyan-700 dark:hover:bg-gray-700 forced-colors:appearance-auto">
            <option>Yes</option>
            <option>No</option>
            <option>Maybe</option>
         </select>
      </div>
      <div class="mx-6 text-sm font-semibold text-gray-900 dark:text-gray-200">Remove default browser styles</div>
   </div>
</div>